module.exports = __webpack_public_path__ + "static/media/mobile_sirenje.bb73226a.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/mobile_sirenje.gif
 ** module id = 639
 ** module chunks = 0
 **/